import { FlexibleColumn } from '@ip-only/front-end-library';

const addressColumn: FlexibleColumn = {
  id: 'address',
  header: 'ordersOverview.tableHeaders.address',
  alignment: 'left',
};

const completedDateColumn: FlexibleColumn = {
  id: 'completedDate',
  header: 'ordersOverview.tableHeaders.completedDate',
  alignment: 'left',
};

const customerNameColumn: FlexibleColumn = {
  id: 'customerName',
  header: 'ordersOverview.tableHeaders.customerName',
  alignment: 'left',
};

const statusColumn: FlexibleColumn = {
  id: 'latestStatus',
  header: 'ordersOverview.tableHeaders.latestStatus',
  alignment: 'left',
};

const statusDateColumn: FlexibleColumn = {
  id: 'statusDate',
  header: 'ordersOverview.tableHeaders.statusDate',
  alignment: 'left',
};

const netAdminIdColumn: FlexibleColumn = {
  id: 'netAdminId',
  header: 'NetAdmin ID',
  alignment: 'left',
};

const customerInstallationDateColumn: FlexibleColumn = {
  id: 'customerInstallationDate',
  header: 'ordersOverview.tableHeaders.customerInstallationDate',
  alignment: 'left',
};

const plotDesignDateColumn: FlexibleColumn = {
  id: 'plotDesignDate',
  header: 'ordersOverview.tableHeaders.plotDesignDate',
  alignment: 'left',
};

const preinstallationDateColumn: FlexibleColumn = {
  id: 'preinstallationDate',
  header: 'ordersOverview.tableHeaders.preinstallationDate',
  alignment: 'left',
};

const plotExcavationDateColumn: FlexibleColumn = {
  id: 'plotExcavationDate',
  header: 'ordersOverview.tableHeaders.plotExcavationDate',
  alignment: 'left',
};

const ductConnectionColumn: FlexibleColumn = {
  id: 'ductConnection',
  header: 'ordersOverview.tableHeaders.ductConnection',
  alignment: 'left',
};

const cableBlowingDateColumn: FlexibleColumn = {
  id: 'cableBlowingDate',
  header: 'ordersOverview.tableHeaders.cableBlowingDate',
  alignment: 'left',
};

const splicingAndMeasuringDateColumn: FlexibleColumn = {
  id: 'splicingAndMeasuringDate',
  header: 'ordersOverview.tableHeaders.splicingAndMeasuringDate',
  alignment: 'left',
};

const commissioningDateColumn: FlexibleColumn = {
  id: 'commissioningDate',
  header: 'ordersOverview.tableHeaders.commissioningDate',
  alignment: 'left',
};

const macAddressColumn: FlexibleColumn = {
  id: 'macAddress',
  header: 'ordersOverview.tableHeaders.macAddress',
  alignment: 'left',
};

const pdfColumn: FlexibleColumn = {
  id: 'pdf',
  header: 'PDF',
  alignment: 'left',
};

export const swedenColumns: FlexibleColumn[] = [
  addressColumn,
  customerNameColumn,
  pdfColumn,
  customerInstallationDateColumn,
  statusColumn,
  statusDateColumn,
  netAdminIdColumn,
  plotDesignDateColumn,
  preinstallationDateColumn,
  plotExcavationDateColumn,
  ductConnectionColumn,
  cableBlowingDateColumn,
  splicingAndMeasuringDateColumn,
  commissioningDateColumn,
  macAddressColumn,
];

export const finlandColumns: FlexibleColumn[] = [
  addressColumn,
  completedDateColumn,
  customerNameColumn,
  pdfColumn,
  customerInstallationDateColumn,
  statusColumn,
  statusDateColumn,
  netAdminIdColumn,
  plotDesignDateColumn,
  preinstallationDateColumn,
  plotExcavationDateColumn,
  ductConnectionColumn,
  cableBlowingDateColumn,
  splicingAndMeasuringDateColumn,
  commissioningDateColumn,
  macAddressColumn,
];
